module.exports = __webpack_public_path__ + "img/pg4-title.34540d53.png";